import { render } from "./EighthComponent.vue?vue&type=template&id=bfbf7874&scoped=true"
import script from "./EighthComponent.vue?vue&type=script&lang=js"
export * from "./EighthComponent.vue?vue&type=script&lang=js"

import "./EighthComponent.vue?vue&type=style&index=0&id=bfbf7874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbf7874"]])

export default __exports__